define('views/content/reseller_roles',['require','views/base/list_page_view','views/components/reseller_role/reseller_roles','collections/reseller_roles','text!templates/content/reseller_roles.html'],function(request){

    var BaseListPageView = require('views/base/list_page_view');

    var RoleView = require('views/components/reseller_role/reseller_roles');
    var ResellerRolesCollection = require('collections/reseller_roles');

    var temp = require("text!templates/content/reseller_roles.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'reseller-roles-page',
        titleKey: 'personal_roles',

        setCollection: function () {
            this.collection = new ResellerRolesCollection();
        },

        onRender: function() {
            this.ListContainer.show(new RoleView({
                collection: this.collection
            }));
        }

    });
});
